import { Button, IconButton, Tag } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { CircleInfo, EditPencil01 } from "@core/icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./UserRoleCard.module.css";
import type { UserRoleCardProps } from "./UserRoleCard.types";
import { AccessManagerCard } from "../AccessManagerCard/AccessManagerCard";

export const UserRoleCard: FC<UserRoleCardProps> = ({ onClick, role }) => {
  const { t } = useCustomTranslation(["main", "common"]);

  return (
    <AccessManagerCard
      dataTestId="card-user-role"
      pictoWithToolTip={
        <IconButton
          canShowTooltip
          data-testid="Tooltip-UserRole"
          icon={CircleInfo}
          size="lg"
          tooltipMessage={t(`userDetails.role.tooltip.${role}`)}
          variant="tertiary"
        />
      }
      title={t("userDetails.role.title")}
    >
      <div className={classes.row}>
        {role === "admin" && (
          <Tag
            color="contrast"
            label={t("userDetails.role.labels.admin")}
            size="xs"
          />
        )}
        {role === "restricted" && (
          <Tag label={t("userDetails.role.labels.restricted")} size="xs" />
        )}
        <Button
          data-testid="button-edit-userRole"
          onClick={onClick}
          startIcon={EditPencil01}
          variant="secondary"
        >
          {t("button.edit", { ns: "common" })}
        </Button>
      </div>
    </AccessManagerCard>
  );
};
